import { lazy } from 'react';
const Login = lazy(() => import('../containers/loginContainer'));
const CourseHome = lazy(() => import('../containers/Course/courseHomeContainer'));
const StudySessionMain = lazy(() => import('../containers/StudySession/studySessionMainContainer'));
const PracticeExamResultsView = lazy(() =>
  import('../containers/Course/practiceExamFinalResultsContainer')
);
const LessonMainView = lazy(() => import('../components/Content/lessonMainView'));
const ExamSession = lazy(() => import('../containers/ExamSession/examSessionMainContainer'));
const ChooseCourse = lazy(() => import('../containers/Course/chooseCourseContainer'));
const ReviewExamView = lazy(() => import('../containers/ExamSession/reviewExamContainer'));
const CreateAccount = lazy(() => import('../containers/SignUp/createAccountMainContainer'));
const PurchaseCourse = lazy(() => import('../containers/SignUp/purchaseCourseContainer'));

const routes = [
  {
    path: 'login',
    name: 'login',
    layout: '/',
    component: Login
  },
  {
    path: 'courseHome',
    name: 'courseHome',
    layout: '/',
    component: CourseHome
  },
  {
    path: 'studySession',
    name: 'studySession',
    layout: '/',
    component: StudySessionMain
  },
  {
    path: 'practiceExamResults',
    name: 'practiceExamResults',
    layout: '/',
    component: PracticeExamResultsView
  },
  {
    path: 'examReview',
    name: 'examReview',
    layout: '/',
    component: ReviewExamView
  },
  {
    path: 'lesson',
    name: 'lesson',
    layout: '/',
    component: LessonMainView
  },
  {
    path: 'examSession',
    name: 'examSession',
    layout: '/',
    component: ExamSession
  },
  {
    path: 'chooseCourse',
    name: 'chooseCourse',
    layout: '/',
    component: ChooseCourse
  },
  {
    path: 'chooseCourse',
    name: 'chooseCourse',
    layout: '/',
    component: ChooseCourse
  },
  {
    path: 'signUp',
    name: 'signUp',
    layout: '/',
    component: Login
  },
  {
    path: 'newAccount',
    name: 'newAccount',
    layout: '/',
    component: CreateAccount
  },
  {
    path: 'purchase',
    name: 'purchase',
    layout: '/',
    component: PurchaseCourse
  },
  {
    path: '*',
    name: 'none',
    layout: '/',
    component: Login
  }
];

export default routes;
